export const useMultiroomCountText = (roomsCount: number) => {
  if (roomsCount < 2) {
    return "";
  }
  return `(${roomsCount} Rooms)`;
};
